import './App.css';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { lazy, Suspense, useState } from 'react';

// const Protected=lazy(()=>'./component/Protected.js')
// const Assesment=lazy(()=>import('./component/Assesment'));
// const Createperson=lazy(()=>import('./component/Createperson'));
// const Home=lazy(()=>import('./component/Home'));

import Protected from './component/Protected';
import Assesment from './component/Assesment';
import Createperson from './component/Createperson';
import Home from './component/Home'
import NotFound from './component/Notfound';

function App() {
  
  return (

    
    <div className="App">
      <BrowserRouter>
      <Suspense fallback={<>loading......!</>}>
      <Routes>
      
      <Route path='/login' element ={
<Protected>
        <Assesment/>
        </Protected>
        }/>
      <Route path='login/home/' element ={<Createperson/>}/>
      <Route path='/' element ={<Home/>}/>
      


      <Route path="*" element={<NotFound />} /> 
      
      </Routes>
      </Suspense>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
